<!--  -->
<template>
  <div>
    <el-tag
      v-for="itemr,index in labelarr"
      :key="index"
      class="tag_box"
    >{{ itemr.tag_name }}</el-tag>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    optionsr: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      labelarr: []
    }
  },
  created() {
    console.log('optionsr', this.optionsr)
  },
  mounted() {

  },
  methods: {
    labelsend(val) {
      this.optionsr.forEach((item) => {
        if (item.id === val) {
          this.labelarr = JSON.parse(item.tag_ids)
          console.log('tag_ids', JSON.parse(item.tag_ids))
        }
      })
      // console.log('val', val, this.optionsr)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tag_box{
  margin: 0px 10px 10px 0px;
}
</style>
